import React, { useRef, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import './BiginForm.css';

interface BiginFormProps {
  className?: string;
}

const BiginForm: React.FC<BiginFormProps> = ({ 
  className = '' 
}) => {
  const { i18n } = useTranslation();
  const iframeRef = useRef<HTMLIFrameElement>(null);

  // Define form URLs based on language
  const getFormUrl = useCallback(() => {
    if (i18n.language === 'fr') {
      return 'https://ca.bigin.online/org110001554715/forms/angles-de-consommation-du-cloud';
    }
    return 'https://ca.bigin.online/org110001554715/forms/download-our-market-study';
  }, [i18n.language]);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    // Update iframe src when language changes
    iframe.src = getFormUrl();

    const resizeIframe = () => {
      try {
        // Try to access the iframe's content
        const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
        if (iframeDoc) {
          const body = iframeDoc.body;
          const html = iframeDoc.documentElement;
          
          // Get the full height of the content
          const height = Math.max(
            body.scrollHeight,
            body.offsetHeight,
            html.clientHeight,
            html.scrollHeight,
            html.offsetHeight
          );
          
          // Set the iframe height to match content + 20px padding
          iframe.style.height = (height + 100) + 'px';
        }
      } catch (error) {
        // Cross-origin restrictions - fallback to a reasonable height + 20px
        iframe.style.height = '620px';
      }
    };

    // Resize when iframe loads
    iframe.onload = () => {
      // Small delay to ensure content is fully rendered
      setTimeout(resizeIframe, 100);
    };

    // Also try to resize after a longer delay in case content loads dynamically
    const timeoutId = setTimeout(resizeIframe, 1000);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [i18n.language, getFormUrl]); // Re-run effect when language changes

  return (
    <div className={`bigin-form-container ${className}`}>
      <div className="bigin-form-wrapper">
        <iframe 
          ref={iframeRef}
          src={getFormUrl()}
          width="100%"
          height="550"
          frameBorder="0"
          title={i18n.language === 'fr' ? 'Télécharger le Guide des 5 Angles Cachés de la Consommation Cloud' : 'Download The 5 Hidden Angles of Cloud Consumption Form'}
          className="bigin-iframe"
        />
      </div>
    </div>
  );
};

export default BiginForm;
